import { format, parseISO } from "date-fns";

export function dateToString(dateObj: Date): string {
  return format(dateObj, "yyyy-MM-dd");
}

export function stringToDate(dateStr: string): Date | null {
  if (!dateStr) return null;
  try {
    return parseISO(dateStr);
  } catch {
    return null;
  }
}

export function substractDateAsString(days: number): string {
  const d = new Date();
  d.setDate(d.getDate() - days);
  return dateToString(d);
}
